var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Head'),_c('router-view'),_c('el-backtop',{attrs:{"right":50,"bottom":50}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }